export const SuperEmojis = [
    {label : "100", content: "💯", type:"entertainment"},
    {label : "1234", content: "🔢", type:"entertainment"},
    {label : "grinning", content: "😀", type:"smiley"},
    {label : "grimacing", content: "😬", type:"smiley"},
    {label : "grin", content: "😁", type:"smiley"},
    {label : "joy", content: "😂", type:"smiley"},
    {label : "rofl", content: "🤣", type:"smiley"},
    {label : "smiley", content: "😃", type:"smiley"},
    {label : "smile", content: "😄", type:"smiley"},
    {label : "sweat-smile", content: "😅", type:"smiley"},
    {label : "laughing", content: "😆", type:"smiley"},
    {label : "innocent", content: "😇", type:"smiley"},
    {label : "wink", content: "😉", type:"smiley"},
    {label : "blush", content: "😊", type:"smiley"},
    {label : "slightly-smiling-face", content: "🙂", type:"smiley"},
    {label : "upside-down-face", content: "🙃", type:"smiley"},
    {label : "yum", content: "😋", type:"smiley"},
    {label : "relieved", content: "😌", type:"smiley"},
    {label : "heart-eyes", content: "😍", type:"smiley"},
    {label : "kissing-heart", content: "😘", type:"smiley"},
    {label : "kissing", content: "😗", type:"smiley"},
    {label : "kissing-smiling-eyes", content: "😙", type:"smiley"},
    {label : "kissing-closed-eyes", content: "😚", type:"smiley"},
    {label : "stuck-out-tongue-winking-eye", content: "😜", type:"smiley"},
    {label : "stuck-out-tongue-closed-eyes", content: "😝", type:"smiley"},
    {label : "stuck-out-tongue", content: "😛", type:"smiley"},
    {label : "money-mouth-face", content: "🤑", type:"smiley"},
    {label : "nerd-face", content: "🤓", type:"smiley"},
    {label : "sunglasses", content: "😎", type:"smiley"},
    {label : "clown-face", content: "🤡", type:"smiley"},
    {label : "cowboy-hat-face", content: "🤠", type:"smiley"},
    {label : "hugs", content: "🤗", type:"smiley"},
    {label : "smirk", content: "😏", type:"smiley"},
    {label : "no-mouth", content: "😶", type:"smiley"},
    {label : "neutral-face", content: "😐", type:"smiley"},
    {label : "expressionless", content: "😑", type:"smiley"},
    {label : "unamused", content: "😒", type:"smiley"},
    {label : "roll-eyes", content: "🙄", type:"smiley"},
    {label : "thinking", content: "🤔", type:"smiley"},
    {label : "lying-face", content: "🤥", type:"smiley"},
    {label : "flushed", content: "😳", type:"smiley"},
    {label : "disappointed", content: "😞", type:"smiley"},
    {label : "worried", content: "😟", type:"smiley"},
    {label : "angry", content: "😠", type:"smiley"},
    {label : "rage", content: "😡", type:"smiley"},
    {label : "pensive", content: "😔", type:"smiley"},
    {label : "confused", content: "😕", type:"smiley"},
    {label : "slightly-frowning-face", content: "🙁", type:"smiley"},
    {label : "frowning-face", content: "☹", type:"smiley"},
    {label : "persevere", content: "😣", type:"smiley"},
    {label : "confounded", content: "😖", type:"smiley"},
    {label : "tired-face", content: "😫", type:"smiley"},
    {label : "weary", content: "😩", type:"smiley"},
    {label : "triumph", content: "😤", type:"smiley"},
    {label : "open-mouth", content: "😮", type:"smiley"},
    {label : "scream", content: "😱", type:"smiley"},
    {label : "fearful", content: "😨", type:"smiley"},
    {label : "cold-sweat", content: "😰", type:"smiley"},
    {label : "hushed", content: "😯", type:"smiley"},
    {label : "frowning", content: "😦", type:"smiley"},
    {label : "anguished", content: "😧", type:"smiley"},
    {label : "cry", content: "😢", type:"smiley"},
    {label : "disappointed-relieved", content: "😥", type:"smiley"},
    {label : "drooling-face", content: "🤤", type:"smiley"},
    {label : "sleepy", content: "😪", type:"smiley"},
    {label : "sweat", content: "😓", type:"smiley"},
    {label : "sob", content: "😭", type:"smiley"},
    {label : "dizzy-face", content: "😵", type:"smiley"},
    {label : "astonished", content: "😲", type:"smiley"},
    {label : "zipper-mouth-face", content: "🤐", type:"smiley"},
    {label : "nauseated-face", content: "🤢", type:"smiley"},
    {label : "sneezing-face", content: "🤧", type:"smiley"},
    {label : "mask", content: "😷", type:"smiley"},
    {label : "face-with-thermometer", content: "🤒", type:"smiley"},
    {label : "face-with-head-bandage", content: "🤕", type:"smiley"},
    {label : "sleeping", content: "😴", type:"smiley"},
    {label : "zzz", content: "💤", type:"smiley"},
    {label : "poop", content: "💩", type:"smiley"},
    {label : "smiling-imp", content: "😈", type:"smiley"},
    {label : "imp", content: "👿", type:"smiley"},
    {label : "japanese-ogre", content: "👹", type:"smiley"},
    {label : "japanese-goblin", content: "👺", type:"smiley"},
    {label : "skull", content: "💀", type:"smiley"},
    {label : "ghost", content: "👻", type:"smiley"},
    {label : "alien", content: "👽", type:"smiley"},
    {label : "robot", content: "🤖", type:"smiley"},
    {label : "smiley-cat", content: "😺", type:"animals"},
    {label : "smile-cat", content: "😸", type:"animals"},
    {label : "joy-cat", content: "😹", type:"animals"},
    {label : "heart-eyes-cat", content: "😻", type:"animals"},
    {label : "smirk-cat", content: "😼", type:"animals"},
    {label : "kissing-cat", content: "😽", type:"animals"},
    {label : "scream-cat", content: "🙀", type:"animals"},
    {label : "crying-cat-face", content: "😿", type:"animals"},
    {label : "pouting-cat", content: "😾", type:"animals"},
    {label : "raised-hands", content: "🙌", type:"hands"},
    {label : "clap", content: "👏", type:"hands"},
    {label : "wave", content: "👋", type:"hands"},
    {label : "call-me-hand", content: "🤙", type:"hands"},
    {label : "plus1", content: "👍", type:"hands"},
    {label : "-1", content: "👎", type:"hands"},
    {label : "facepunch", content: "👊", type:"hands"},
    {label : "fist", content: "✊", type:"hands"},
    {label : "fist-left", content: "🤛", type:"hands"},
    {label : "fist-right", content: "🤜", type:"hands"},
    {label : "v", content: "✌", type:"hands"},
    {label : "ok-hand", content: "👌", type:"hands"},
    {label : "raised-hand", content: "✋", type:"hands"},
    {label : "raised-back-of-hand", content: "🤚", type:"hands"},
    {label : "open-hands", content: "👐", type:"hands"},
    {label : "muscle", content: "💪", type:"hands"},
    {label : "pray", content: "🙏", type:"hands"},
    {label : "handshake", content: "🤝", type:"hands"},
    {label : "point-up", content: "☝", type:"hands"},
    {label : "point-up-2", content: "👆", type:"hands"},
    {label : "point-down", content: "👇", type:"hands"},
    {label : "point-left", content: "👈", type:"hands"},
    {label : "point-right", content: "👉", type:"hands"},
    {label : "fu", content: "🖕", type:"hands"},
    {label : "raised-hand-with-fingers-splayed", content: "🖐", type:"hands"},
    {label : "metal", content: "🤘", type:"hands"},
    {label : "crossed-fingers", content: "🤞", type:"hands"},
    {label : "vulcan-salute", content: "🖖", type:"hands"},
    {label : "writing-hand", content: "✍", type:"hands"},
    {label : "selfie", content: "🤳", type:"hands"},
    {label : "nail-care", content: "💅", type:"hands"},
    {label : "lips", content: "👄", type:"hands"},
    {label : "tongue", content: "👅", type:"hands"},
    {label : "ear", content: "👂", type:"hands"},
    {label : "nose", content: "👃", type:"hands"},
    {label : "eye", content: "👁", type:"hands"},
    {label : "eyes", content: "👀", type:"hands"},
    {label : "bust-in-silhouette", content: "👤", type:"hands"},
    {label : "busts-in-silhouette", content: "👥", type:"hands"},
    {label : "speaking-head", content: "🗣", type:"hands"},
    {label : "baby", content: "👶", type:"people"},
    {label : "boy", content: "👦", type:"people"},
    {label : "girl", content: "👧", type:"people"},
    {label : "man", content: "👨", type:"people"},
    {label : "woman", content: "👩", type:"people"},
    {label : "blonde-man", content: "👱", type:"people"},
    {label : "older-man", content: "👴", type:"people"},
    {label : "older-woman", content: "👵", type:"people"},
    {label : "man-with-gua-pi-mao", content: "👲", type:"people"},
    {label : "man-with-turban", content: "👳", type:"people"},
    {label : "policeman", content: "👮", type:"people"},
    {label : "construction-worker-man", content: "👷", type:"people"},
    {label : "guardsman", content: "💂", type:"people"},
    {label : "male-detective", content: "🕵", type:"people"},
    {label : "mrs-claus", content: "🤶", type:"people"},
    {label : "santa", content: "🎅", type:"people"},
    {label : "angel", content: "👼", type:"people"},
    {label : "pregnant-woman", content: "🤰", type:"people"},
    {label : "princess", content: "👸", type:"people"},
    {label : "prince", content: "🤴", type:"people"},
    {label : "bride-with-veil", content: "👰", type:"people"},
    {label : "man-in-tuxedo", content: "🤵", type:"people"},
    {label : "running-man", content: "🏃", type:"people"},
    {label : "walking-man", content: "🚶", type:"people"},
    {label : "dancer", content: "💃", type:"people"},
    {label : "man-dancing", content: "🕺", type:"people"},
    {label : "dancing-women", content: "👯", type:"people"},
    {label : "couple", content: "👫", type:"people"},
    {label : "two-men-holding-hands", content: "👬", type:"people"},
    {label : "two-women-holding-hands", content: "👭", type:"people"},
    {label : "bowing-man", content: "🙇", type:"people"},
    {label : "man-facepalming", content: "🤦", type:"people"},
    {label : "woman-shrugging", content: "🤷", type:"people"},
    {label : "tipping-hand-woman", content: "💁", type:"people"},
    {label : "no-good-woman", content: "🙅", type:"people"},
    {label : "ok-woman", content: "🙆", type:"people"},
    {label : "raising-hand-woman", content: "🙋", type:"people"},
    {label : "pouting-woman", content: "🙎", type:"people"},
    {label : "frowning-woman", content: "🙍", type:"people"},
    {label : "haircut-woman", content: "💇", type:"people"},
    {label : "massage-woman", content: "💆", type:"people"},
    {label : "couple-with-heart-woman-man", content: "💑", type:"people"},
    {label : "couplekiss-man-woman", content: "💏", type:"people"},
    {label : "family-man-woman-boy", content: "👪", type:"people"},
    {label : "womans-clothes", content: "👚", type:"clothings"},
    {label : "tshirt", content: "👕", type:"clothings"},
    {label : "jeans", content: "👖", type:"clothings"},
    {label : "necktie", content: "👔", type:"clothings"},
    {label : "dress", content: "👗", type:"clothings"},
    {label : "bikini", content: "👙", type:"clothings"},
    {label : "kimono", content: "👘", type:"clothings"},
    {label : "lipstick", content: "💄", type:"clothings"},
    {label : "kiss", content: "💋", type:"clothings"},
    {label : "footprints", content: "👣", type:"clothings"},
    {label : "high-heel", content: "👠", type:"clothings"},
    {label : "sandal", content: "👡", type:"clothings"},
    {label : "boot", content: "👢", type:"clothings"},
    {label : "mans-shoe", content: "👞", type:"clothings"},
    {label : "athletic-shoe", content: "👟", type:"clothings"},
    {label : "womans-hat", content: "👒", type:"clothings"},
    {label : "tophat", content: "🎩", type:"clothings"},
    {label : "rescue-worker-helmet", content: "⛑", type:"clothings"},
    {label : "mortar-board", content: "🎓", type:"clothings"},
    {label : "crown", content: "👑", type:"clothings"},
    {label : "school-satchel", content: "🎒", type:"clothings"},
    {label : "pouch", content: "👝", type:"clothings"},
    {label : "purse", content: "👛", type:"clothings"},
    {label : "handbag", content: "👜", type:"clothings"},
    {label : "briefcase", content: "💼", type:"clothings"},
    {label : "eyeglasses", content: "👓", type:"clothings"},
    {label : "dark-sunglasses", content: "🕶", type:"clothings"},
    {label : "ring", content: "💍", type:"clothings"},
    {label : "closed-umbrella", content: "🌂", type:"clothings"},
    {label : "dog", content: "🐶", type:"animals"},
    {label : "cat", content: "🐱", type:"animals"},
    {label : "mouse", content: "🐭", type:"animals"},
    {label : "hamster", content: "🐹", type:"animals"},
    {label : "rabbit", content: "🐰", type:"animals"},
    {label : "fox-face", content: "🦊", type:"animals"},
    {label : "bear", content: "🐻", type:"animals"},
    {label : "panda-face", content: "🐼", type:"animals"},
    {label : "koala", content: "🐨", type:"animals"},
    {label : "tiger", content: "🐯", type:"animals"},
    {label : "lion", content: "🦁", type:"animals"},
    {label : "cow", content: "🐮", type:"animals"},
    {label : "pig", content: "🐷", type:"animals"},
    {label : "pig-nose", content: "🐽", type:"animals"},
    {label : "frog", content: "🐸", type:"animals"},
    {label : "squid", content: "🦑", type:"animals"},
    {label : "octopus", content: "🐙", type:"animals"},
    {label : "shrimp", content: "🦐", type:"animals"},
    {label : "monkey-face", content: "🐵", type:"animals"},
    {label : "gorilla", content: "🦍", type:"animals"},
    {label : "see-no-evil", content: "🙈", type:"animals"},
    {label : "hear-no-evil", content: "🙉", type:"animals"},
    {label : "speak-no-evil", content: "🙊", type:"animals"},
    {label : "monkey", content: "🐒", type:"animals"},
    {label : "chicken", content: "🐔", type:"animals"},
    {label : "penguin", content: "🐧", type:"animals"},
    {label : "bird", content: "🐦", type:"animals"},
    {label : "baby-chick", content: "🐤", type:"animals"},
    {label : "hatching-chick", content: "🐣", type:"animals"},
    {label : "hatched-chick", content: "🐥", type:"animals"},
    {label : "duck", content: "🦆", type:"animals"},
    {label : "eagle", content: "🦅", type:"animals"},
    {label : "owl", content: "🦉", type:"animals"},
    {label : "bat", content: "🦇", type:"animals"},
    {label : "wolf", content: "🐺", type:"animals"},
    {label : "boar", content: "🐗", type:"animals"},
    {label : "horse", content: "🐴", type:"animals"},
    {label : "unicorn", content: "🦄", type:"animals"},
    {label : "honeybee", content: "🐝", type:"animals"},
    {label : "bug", content: "🐛", type:"animals"},
    {label : "butterfly", content: "🦋", type:"animals"},
    {label : "snail", content: "🐌", type:"animals"},
    {label : "beetle", content: "🐞", type:"animals"},
    {label : "ant", content: "🐜", type:"animals"},
    {label : "spider", content: "🕷", type:"animals"},
    {label : "scorpion", content: "🦂", type:"animals"},
    {label : "crab", content: "🦀", type:"animals"},
    {label : "snake", content: "🐍", type:"animals"},
    {label : "lizard", content: "🦎", type:"animals"},
    {label : "turtle", content: "🐢", type:"animals"},
    {label : "tropical-fish", content: "🐠", type:"animals"},
    {label : "fish", content: "🐟", type:"animals"},
    {label : "blowfish", content: "🐡", type:"animals"},
    {label : "dolphin", content: "🐬", type:"animals"},
    {label : "shark", content: "🦈", type:"animals"},
    {label : "whale", content: "🐳", type:"animals"},
    {label : "whale2", content: "🐋", type:"animals"},
    {label : "crocodile", content: "🐊", type:"animals"},
    {label : "leopard", content: "🐆", type:"animals"},
    {label : "tiger2", content: "🐅", type:"animals"},
    {label : "water-buffalo", content: "🐃", type:"animals"},
    {label : "ox", content: "🐂", type:"animals"},
    {label : "cow2", content: "🐄", type:"animals"},
    {label : "deer", content: "🦌", type:"animals"},
    {label : "dromedary-camel", content: "🐪", type:"animals"},
    {label : "camel", content: "🐫", type:"animals"},
    {label : "elephant", content: "🐘", type:"animals"},
    {label : "rhinoceros", content: "🦏", type:"animals"},
    {label : "goat", content: "🐐", type:"animals"},
    {label : "ram", content: "🐏", type:"animals"},
    {label : "sheep", content: "🐑", type:"animals"},
    {label : "racehorse", content: "🐎", type:"animals"},
    {label : "pig2", content: "🐖", type:"animals"},
    {label : "rat", content: "🐀", type:"animals"},
    {label : "mouse2", content: "🐁", type:"animals"},
    {label : "rooster", content: "🐓", type:"animals"},
    {label : "turkey", content: "🦃", type:"animals"},
    {label : "dove", content: "🕊", type:"animals"},
    {label : "dog2", content: "🐕", type:"animals"},
    {label : "poodle", content: "🐩", type:"animals"},
    {label : "cat2", content: "🐈", type:"animals"},
    {label : "rabbit2", content: "🐇", type:"animals"},
    {label : "chipmunk", content: "🐿", type:"animals"},
    {label : "paw-prints", content: "🐾", type:"animals"},
    {label : "dragon", content: "🐉", type:"animals"},
    {label : "dragon-face", content: "🐲", type:"animals"},
    {label : "cactus", content: "🌵", type:"nature"},
    {label : "christmas-tree", content: "🎄", type:"nature"},
    {label : "evergreen-tree", content: "🌲", type:"nature"},
    {label : "deciduous-tree", content: "🌳", type:"nature"},
    {label : "palm-tree", content: "🌴", type:"nature"},
    {label : "seedling", content: "🌱", type:"nature"},
    {label : "herb", content: "🌿", type:"nature"},
    {label : "shamrock", content: "☘", type:"nature"},
    {label : "four-leaf-clover", content: "🍀", type:"nature"},
    {label : "bamboo", content: "🎍", type:"nature"},
    {label : "tanabata-tree", content: "🎋", type:"nature"},
    {label : "leaves", content: "🍃", type:"nature"},
    {label : "fallen-leaf", content: "🍂", type:"nature"},
    {label : "maple-leaf", content: "🍁", type:"nature"},
    {label : "ear-of-rice", content: "🌾", type:"nature"},
    {label : "hibiscus", content: "🌺", type:"nature"},
    {label : "sunflower", content: "🌻", type:"nature"},
    {label : "rose", content: "🌹", type:"nature"},
    {label : "wilted-flower", content: "🥀", type:"nature"},
    {label : "tulip", content: "🌷", type:"nature"},
    {label : "blossom", content: "🌼", type:"nature"},
    {label : "cherry-blossom", content: "🌸", type:"nature"},
    {label : "bouquet", content: "💐", type:"nature"},
    {label : "mushroom", content: "🍄", type:"nature"},
    {label : "chestnut", content: "🌰", type:"nature"},
    {label : "jack-o-lantern", content: "🎃", type:"nature"},
    {label : "shell", content: "🐚", type:"nature"},
    {label : "spider-web", content: "🕸", type:"nature"},
    {label : "earth-americas", content: "🌎", type:"meteo"},
    {label : "earth-africa", content: "🌍", type:"meteo"},
    {label : "earth-asia", content: "🌏", type:"meteo"},
    {label : "full-moon", content: "🌕", type:"meteo"},
    {label : "waning-gibbous-moon", content: "🌖", type:"meteo"},
    {label : "last-quarter-moon", content: "🌗", type:"meteo"},
    {label : "waning-crescent-moon", content: "🌘", type:"meteo"},
    {label : "new-moon", content: "🌑", type:"meteo"},
    {label : "waxing-crescent-moon", content: "🌒", type:"meteo"},
    {label : "first-quarter-moon", content: "🌓", type:"meteo"},
    {label : "waxing-gibbous-moon", content: "🌔", type:"meteo"},
    {label : "new-moon-with-face", content: "🌚", type:"meteo"},
    {label : "full-moon-with-face", content: "🌝", type:"meteo"},
    {label : "first-quarter-moon-with-face", content: "🌛", type:"meteo"},
    {label : "last-quarter-moon-with-face", content: "🌜", type:"meteo"},
    {label : "sun-with-face", content: "🌞", type:"meteo"},
    {label : "crescent-moon", content: "🌙", type:"meteo"},
    {label : "star", content: "⭐", type:"meteo"},
    {label : "star2", content: "🌟", type:"meteo"},
    {label : "dizzy", content: "💫", type:"meteo"},
    {label : "sparkles", content: "✨", type:"meteo"},
    {label : "comet", content: "☄", type:"meteo"},
    {label : "sun-behind-small-cloud", content: "🌤", type:"meteo"},
    {label : "partly-sunny", content: "⛅", type:"meteo"},
    {label : "sun-behind-large-cloud", content: "🌥", type:"meteo"},
    {label : "sun-behind-rain-cloud", content: "🌦", type:"meteo"},
    {label : "cloud-with-rain", content: "🌧", type:"meteo"},
    {label : "cloud-with-lightning-and-rain", content: "⛈", type:"meteo"},
    {label : "cloud-with-lightning", content: "🌩", type:"meteo"},
    {label : "zap", content: "⚡", type:"meteo"},
    {label : "fire", content: "🔥", type:"meteo"},
    {label : "boom", content: "💥", type:"meteo"},
    {label : "cloud-with-snow", content: "🌨", type:"meteo"},
    {label : "snowman", content: "⛄", type:"meteo"},
    {label : "snowman-with-snow", content: "☃", type:"meteo"},
    {label : "wind-face", content: "🌬", type:"meteo"},
    {label : "dash", content: "💨", type:"meteo"},
    {label : "tornado", content: "🌪", type:"meteo"},
    {label : "fog", content: "🌫", type:"meteo"},
    {label : "open-umbrella", content: "☂", type:"meteo"},
    {label : "umbrella", content: "☔", type:"meteo"},
    {label : "droplet", content: "💧", type:"meteo"},
    {label : "sweat-drops", content: "💦", type:"meteo"},
    {label : "ocean", content: "🌊", type:"meteo"},
    {label : "green-apple", content: "🍏", type:"food"},
    {label : "apple", content: "🍎", type:"food"},
    {label : "pear", content: "🍐", type:"food"},
    {label : "tangerine", content: "🍊", type:"food"},
    {label : "lemon", content: "🍋", type:"food"},
    {label : "banana", content: "🍌", type:"food"},
    {label : "watermelon", content: "🍉", type:"food"},
    {label : "grapes", content: "🍇", type:"food"},
    {label : "strawberry", content: "🍓", type:"food"},
    {label : "melon", content: "🍈", type:"food"},
    {label : "cherries", content: "🍒", type:"food"},
    {label : "peach", content: "🍑", type:"food"},
    {label : "pineapple", content: "🍍", type:"food"},
    {label : "kiwi-fruit", content: "🥝", type:"food"},
    {label : "avocado", content: "🥑", type:"food"},
    {label : "tomato", content: "🍅", type:"food"},
    {label : "eggplant", content: "🍆", type:"food"},
    {label : "cucumber", content: "🥒", type:"food"},
    {label : "carrot", content: "🥕", type:"food"},
    {label : "hot-pepper", content: "🌶", type:"food"},
    {label : "potato", content: "🥔", type:"food"},
    {label : "corn", content: "🌽", type:"food"},
    {label : "sweet-potato", content: "🍠", type:"food"},
    {label : "peanuts", content: "🥜", type:"food"},
    {label : "honey-pot", content: "🍯", type:"food"},
    {label : "croissant", content: "🥐", type:"food"},
    {label : "bread", content: "🍞", type:"food"},
    {label : "baguette-bread", content: "🥖", type:"food"},
    {label : "cheese", content: "🧀", type:"food"},
    {label : "egg", content: "🥚", type:"food"},
    {label : "bacon", content: "🥓", type:"food"},
    {label : "pancakes", content: "🥞", type:"food"},
    {label : "poultry-leg", content: "🍗", type:"food"},
    {label : "meat-on-bone", content: "🍖", type:"food"},
    {label : "fried-shrimp", content: "🍤", type:"food"},
    {label : "fried-egg", content: "🍳", type:"food"},
    {label : "hamburger", content: "🍔", type:"food"},
    {label : "fries", content: "🍟", type:"food"},
    {label : "stuffed-flatbread", content: "🥙", type:"food"},
    {label : "hotdog", content: "🌭", type:"food"},
    {label : "pizza", content: "🍕", type:"food"},
    {label : "spaghetti", content: "🍝", type:"food"},
    {label : "taco", content: "🌮", type:"food"},
    {label : "burrito", content: "🌯", type:"food"},
    {label : "green-salad", content: "🥗", type:"food"},
    {label : "shallow-pan-of-food", content: "🥘", type:"food"},
    {label : "ramen", content: "🍜", type:"food"},
    {label : "stew", content: "🍲", type:"food"},
    {label : "fish-cake", content: "🍥", type:"food"},
    {label : "sushi", content: "🍣", type:"food"},
    {label : "bento", content: "🍱", type:"food"},
    {label : "curry", content: "🍛", type:"food"},
    {label : "rice-ball", content: "🍙", type:"food"},
    {label : "rice", content: "🍚", type:"food"},
    {label : "rice-cracker", content: "🍘", type:"food"},
    {label : "oden", content: "🍢", type:"food"},
    {label : "dango", content: "🍡", type:"food"},
    {label : "shaved-ice", content: "🍧", type:"food"},
    {label : "ice-cream", content: "🍨", type:"food"},
    {label : "icecream", content: "🍦", type:"food"},
    {label : "cake", content: "🍰", type:"food"},
    {label : "birthday", content: "🎂", type:"food"},
    {label : "custard", content: "🍮", type:"food"},
    {label : "candy", content: "🍬", type:"food"},
    {label : "lollipop", content: "🍭", type:"food"},
    {label : "chocolate-bar", content: "🍫", type:"food"},
    {label : "popcorn", content: "🍿", type:"food"},
    {label : "doughnut", content: "🍩", type:"food"},
    {label : "cookie", content: "🍪", type:"food"},
    {label : "milk-glass", content: "🥛", type:"food"},
    {label : "beer", content: "🍺", type:"food"},
    {label : "beers", content: "🍻", type:"food"},
    {label : "clinking-glasses", content: "🥂", type:"food"},
    {label : "wine-glass", content: "🍷", type:"food"},
    {label : "tumbler-glass", content: "🥃", type:"food"},
    {label : "cocktail", content: "🍸", type:"food"},
    {label : "tropical-drink", content: "🍹", type:"food"},
    {label : "champagne", content: "🍾", type:"food"},
    {label : "sake", content: "🍶", type:"food"},
    {label : "tea", content: "🍵", type:"food"},
    {label : "coffee", content: "☕", type:"food"},
    {label : "baby-bottle", content: "🍼", type:"food"},
    {label : "spoon", content: "🥄", type:"food"},
    {label : "fork-and-knife", content: "🍴", type:"food"},
    {label : "plate-with-cutlery", content: "🍽", type:"food"},
    {label : "soccer", content: "⚽", type:"entertainment"},
    {label : "basketball", content: "🏀", type:"entertainment"},
    {label : "football", content: "🏈", type:"entertainment"},
    {label : "baseball", content: "⚾", type:"entertainment"},
    {label : "tennis", content: "🎾", type:"entertainment"},
    {label : "volleyball", content: "🏐", type:"entertainment"},
    {label : "rugby-football", content: "🏉", type:"entertainment"},
    {label : "8ball", content: "🎱", type:"entertainment"},
    {label : "golf", content: "⛳", type:"entertainment"},
    {label : "golfing-man", content: "🏌", type:"entertainment"},
    {label : "ping-pong", content: "🏓", type:"entertainment"},
    {label : "badminton", content: "🏸", type:"entertainment"},
    {label : "goal-net", content: "🥅", type:"entertainment"},
    {label : "ice-hockey", content: "🏒", type:"entertainment"},
    {label : "field-hockey", content: "🏑", type:"entertainment"},
    {label : "cricket", content: "🏏", type:"entertainment"},
    {label : "ski", content: "🎿", type:"entertainment"},
    {label : "skier", content: "⛷", type:"entertainment"},
    {label : "snowboarder", content: "🏂", type:"entertainment"},
    {label : "person-fencing", content: "🤺", type:"entertainment"},
    {label : "ice-skate", content: "⛸", type:"entertainment"},
    {label : "bow-and-arrow", content: "🏹", type:"entertainment"},
    {label : "fishing-pole-and-fish", content: "🎣", type:"entertainment"},
    {label : "boxing-glove", content: "🥊", type:"entertainment"},
    {label : "martial-arts-uniform", content: "🥋", type:"entertainment"},
    {label : "rowing-man", content: "🚣", type:"entertainment"},
    {label : "swimming-man", content: "🏊", type:"entertainment"},
    {label : "surfing-man", content: "🏄", type:"entertainment"},
    {label : "bath", content: "🛀", type:"entertainment"},
    {label : "basketball-man", content: "⛹", type:"entertainment"},
    {label : "weight-lifting-man", content: "🏋", type:"entertainment"},
    {label : "biking-man", content: "🚴", type:"entertainment"},
    {label : "mountain-biking-man", content: "🚵", type:"entertainment"},
    {label : "horse-racing", content: "🏇", type:"entertainment"},
    {label : "business-suit-levitating", content: "🕴", type:"entertainment"},
    {label : "trophy", content: "🏆", type:"entertainment"},
    {label : "running-shirt-with-sash", content: "🎽", type:"entertainment"},
    {label : "medal-sports", content: "🏅", type:"entertainment"},
    {label : "medal-military", content: "🎖", type:"entertainment"},
    {label : "1st-place-medal", content: "🥇", type:"entertainment"},
    {label : "2nd-place-medal", content: "🥈", type:"entertainment"},
    {label : "3rd-place-medal", content: "🥉", type:"entertainment"},
    {label : "reminder-ribbon", content: "🎗", type:"entertainment"},
    {label : "rosette", content: "🏵", type:"entertainment"},
    {label : "ticket", content: "🎫", type:"entertainment"},
    {label : "tickets", content: "🎟", type:"entertainment"},
    {label : "performing-arts", content: "🎭", type:"entertainment"},
    {label : "art", content: "🎨", type:"entertainment"},
    {label : "circus-tent", content: "🎪", type:"entertainment"},
    {label : "microphone", content: "🎤", type:"entertainment"},
    {label : "headphones", content: "🎧", type:"entertainment"},
    {label : "musical-score", content: "🎼", type:"entertainment"},
    {label : "musical-keyboard", content: "🎹", type:"entertainment"},
    {label : "drum", content: "🥁", type:"entertainment"},
    {label : "saxophone", content: "🎷", type:"entertainment"},
    {label : "trumpet", content: "🎺", type:"entertainment"},
    {label : "guitar", content: "🎸", type:"entertainment"},
    {label : "violin", content: "🎻", type:"entertainment"},
    {label : "clapper", content: "🎬", type:"entertainment"},
    {label : "video-game", content: "🎮", type:"entertainment"},
    {label : "space-invader", content: "👾", type:"entertainment"},
    {label : "dart", content: "🎯", type:"entertainment"},
    {label : "game-die", content: "🎲", type:"entertainment"},
    {label : "slot-machine", content: "🎰", type:"entertainment"},
    {label : "bowling", content: "🎳", type:"entertainment"},
    {label : "red-car", content: "🚗", type:"mobility"},
    {label : "taxi", content: "🚕", type:"mobility"},
    {label : "blue-car", content: "🚙", type:"mobility"},
    {label : "bus", content: "🚌", type:"mobility"},
    {label : "trolleybus", content: "🚎", type:"mobility"},
    {label : "racing-car", content: "🏎", type:"mobility"},
    {label : "police-car", content: "🚓", type:"mobility"},
    {label : "ambulance", content: "🚑", type:"mobility"},
    {label : "fire-engine", content: "🚒", type:"mobility"},
    {label : "minibus", content: "🚐", type:"mobility"},
    {label : "truck", content: "🚚", type:"mobility"},
    {label : "articulated-lorry", content: "🚛", type:"mobility"},
    {label : "tractor", content: "🚜", type:"mobility"},
    {label : "kick-scooter", content: "🛴", type:"mobility"},
    {label : "motorcycle", content: "🏍", type:"mobility"},
    {label : "bike", content: "🚲", type:"mobility"},
    {label : "motor-scooter", content: "🛵", type:"mobility"},
    {label : "rotating-light", content: "🚨", type:"mobility"},
    {label : "oncoming-police-car", content: "🚔", type:"mobility"},
    {label : "oncoming-bus", content: "🚍", type:"mobility"},
    {label : "oncoming-automobile", content: "🚘", type:"mobility"},
    {label : "oncoming-taxi", content: "🚖", type:"mobility"},
    {label : "aerial-tramway", content: "🚡", type:"mobility"},
    {label : "mountain-cableway", content: "🚠", type:"mobility"},
    {label : "suspension-railway", content: "🚟", type:"mobility"},
    {label : "railway-car", content: "🚃", type:"mobility"},
    {label : "train", content: "🚋", type:"mobility"},
    {label : "monorail", content: "🚝", type:"mobility"},
    {label : "bullettrain-side", content: "🚄", type:"mobility"},
    {label : "bullettrain-front", content: "🚅", type:"mobility"},
    {label : "light-rail", content: "🚈", type:"mobility"},
    {label : "mountain-railway", content: "🚞", type:"mobility"},
    {label : "steam-locomotive", content: "🚂", type:"mobility"},
    {label : "train2", content: "🚆", type:"mobility"},
    {label : "metro", content: "🚇", type:"mobility"},
    {label : "tram", content: "🚊", type:"mobility"},
    {label : "station", content: "🚉", type:"mobility"},
    {label : "helicopter", content: "🚁", type:"mobility"},
    {label : "small-airplane", content: "🛩", type:"mobility"},
    {label : "flight-departure", content: "🛫", type:"mobility"},
    {label : "flight-arrival", content: "🛬", type:"mobility"},
    {label : "sailboat", content: "⛵", type:"mobility"},
    {label : "motor-boat", content: "🛥", type:"mobility"},
    {label : "speedboat", content: "🚤", type:"mobility"},
    {label : "ferry", content: "⛴", type:"mobility"},
    {label : "passenger-ship", content: "🛳", type:"mobility"},
    {label : "rocket", content: "🚀", type:"mobility"},
    {label : "artificial-satellite", content: "🛰", type:"mobility"},
    {label : "seat", content: "💺", type:"mobility"},
    {label : "canoe", content: "🛶", type:"mobility"},
    {label : "anchor", content: "⚓", type:"mobility"},
    {label : "construction", content: "🚧", type:"mobility"},
    {label : "fuelpump", content: "⛽", type:"mobility"},
    {label : "busstop", content: "🚏", type:"mobility"},
    {label : "vertical-traffic-light", content: "🚦", type:"mobility"},
    {label : "traffic-light", content: "🚥", type:"mobility"},
    {label : "checkered-flag", content: "🏁", type:"mobility"},
    {label : "ship", content: "🚢", type:"mobility"},
    {label : "ferris-wheel", content: "🎡", type:"entertainment"},
    {label : "roller-coaster", content: "🎢", type:"entertainment"},
    {label : "carousel-horse", content: "🎠", type:"entertainment"},
    {label : "building-construction", content: "🏗", type:"home"},
    {label : "foggy", content: "🌁", type:"home"},
    {label : "tokyo-tower", content: "🗼", type:"home"},
    {label : "factory", content: "🏭", type:"home"},
    {label : "fountain", content: "⛲", type:"home"},
    {label : "rice-scene", content: "🎑", type:"home"},
    {label : "mountain", content: "⛰", type:"home"},
    {label : "mountain-snow", content: "🏔", type:"home"},
    {label : "mount-fuji", content: "🗻", type:"home"},
    {label : "volcano", content: "🌋", type:"home"},
    {label : "japan", content: "🗾", type:"home"},
    {label : "camping", content: "🏕", type:"home"},
    {label : "tent", content: "⛺", type:"home"},
    {label : "national-park", content: "🏞", type:"home"},
    {label : "motorway", content: "🛣", type:"home"},
    {label : "railway-track", content: "🛤", type:"home"},
    {label : "sunrise", content: "🌅", type:"home"},
    {label : "sunrise-over-mountains", content: "🌄", type:"home"},
    {label : "desert", content: "🏜", type:"home"},
    {label : "beach-umbrella", content: "🏖", type:"home"},
    {label : "desert-island", content: "🏝", type:"home"},
    {label : "city-sunrise", content: "🌇", type:"home"},
    {label : "city-sunset", content: "🌆", type:"home"},
    {label : "cityscape", content: "🏙", type:"home"},
    {label : "night-with-stars", content: "🌃", type:"home"},
    {label : "bridge-at-night", content: "🌉", type:"home"},
    {label : "milky-way", content: "🌌", type:"entertainment"},
    {label : "stars", content: "🌠", type:"entertainment"},
    {label : "sparkler", content: "🎇", type:"entertainment"},
    {label : "fireworks", content: "🎆", type:"entertainment"},
    {label : "rainbow", content: "🌈", type:"entertainment"},
    {label : "houses", content: "🏘", type:"home"},
    {label : "european-castle", content: "🏰", type:"home"},
    {label : "japanese-castle", content: "🏯", type:"home"},
    {label : "stadium", content: "🏟", type:"home"},
    {label : "statue-of-liberty", content: "🗽", type:"home"},
    {label : "house", content: "🏠", type:"home"},
    {label : "house-with-garden", content: "🏡", type:"home"},
    {label : "derelict-house", content: "🏚", type:"home"},
    {label : "office", content: "🏢", type:"home"},
    {label : "department-store", content: "🏬", type:"home"},
    {label : "post-office", content: "🏣", type:"home"},
    {label : "european-post-office", content: "🏤", type:"home"},
    {label : "hospital", content: "🏥", type:"home"},
    {label : "bank", content: "🏦", type:"home"},
    {label : "hotel", content: "🏨", type:"home"},
    {label : "convenience-store", content: "🏪", type:"home"},
    {label : "school", content: "🏫", type:"home"},
    {label : "love-hotel", content: "🏩", type:"home"},
    {label : "wedding", content: "💒", type:"home"},
    {label : "classical-building", content: "🏛", type:"home"},
    {label : "church", content: "⛪", type:"home"},
    {label : "mosque", content: "🕌", type:"home"},
    {label : "synagogue", content: "🕍", type:"home"},
    {label : "kaaba", content: "🕋", type:"tools"},
    {label : "shinto-shrine", content: "⛩", type:"tools"},
    {label : "watch", content: "⌚", type:"tools"},
    {label : "iphone", content: "📱", type:"tools"},
    {label : "calling", content: "📲", type:"tools"},
    {label : "computer", content: "💻", type:"tools"},
    {label : "keyboard", content: "⌨", type:"tools"},
    {label : "desktop-computer", content: "🖥", type:"tools"},
    {label : "printer", content: "🖨", type:"tools"},
    {label : "computer-mouse", content: "🖱", type:"tools"},
    {label : "trackball", content: "🖲", type:"tools"},
    {label : "joystick", content: "🕹", type:"tools"},
    {label : "clamp", content: "🗜", type:"tools"},
    {label : "minidisc", content: "💽", type:"tools"},
    {label : "floppy-disk", content: "💾", type:"tools"},
    {label : "cd", content: "💿", type:"tools"},
    {label : "dvd", content: "📀", type:"tools"},
    {label : "vhs", content: "📼", type:"tools"},
    {label : "camera", content: "📷", type:"tools"},
    {label : "camera-flash", content: "📸", type:"tools"},
    {label : "video-camera", content: "📹", type:"tools"},
    {label : "movie-camera", content: "🎥", type:"tools"},
    {label : "film-projector", content: "📽", type:"tools"},
    {label : "film-strip", content: "🎞", type:"tools"},
    {label : "telephone-receiver", content: "📞", type:"tools"},
    {label : "pager", content: "📟", type:"tools"},
    {label : "fax", content: "📠", type:"tools"},
    {label : "tv", content: "📺", type:"tools"},
    {label : "radio", content: "📻", type:"tools"},
    {label : "studio-microphone", content: "🎙", type:"tools"},
    {label : "level-slider", content: "🎚", type:"tools"},
    {label : "control-knobs", content: "🎛", type:"tools"},
    {label : "stopwatch", content: "⏱", type:"tools"},
    {label : "timer-clock", content: "⏲", type:"tools"},
    {label : "alarm-clock", content: "⏰", type:"tools"},
    {label : "mantelpiece-clock", content: "🕰", type:"tools"},
    {label : "hourglass-flowing-sand", content: "⏳", type:"tools"},
    {label : "hourglass", content: "⌛", type:"tools"},
    {label : "satellite", content: "📡", type:"tools"},
    {label : "battery", content: "🔋", type:"tools"},
    {label : "electric-plug", content: "🔌", type:"tools"},
    {label : "bulb", content: "💡", type:"tools"},
    {label : "flashlight", content: "🔦", type:"tools"},
    {label : "candle", content: "🕯", type:"tools"},
    {label : "wastebasket", content: "🗑", type:"tools"},
    {label : "oil-drum", content: "🛢", type:"tools"},
    {label : "money-with-wings", content: "💸", type:"tools"},
    {label : "dollar", content: "💵", type:"tools"},
    {label : "yen", content: "💴", type:"tools"},
    {label : "euro", content: "💶", type:"tools"},
    {label : "pound", content: "💷", type:"tools"},
    {label : "moneybag", content: "💰", type:"tools"},
    {label : "credit-card", content: "💳", type:"tools"},
    {label : "gem", content: "💎", type:"tools"},
    {label : "balance-scale", content: "⚖", type:"tools"},
    {label : "wrench", content: "🔧", type:"tools"},
    {label : "hammer", content: "🔨", type:"tools"},
    {label : "hammer-and-pick", content: "⚒", type:"tools"},
    {label : "hammer-and-wrench", content: "🛠", type:"tools"},
    {label : "pick", content: "⛏", type:"tools"},
    {label : "nut-and-bolt", content: "🔩", type:"tools"},
    {label : "gear", content: "⚙", type:"tools"},
    {label : "chains", content: "⛓", type:"tools"},
    {label : "gun", content: "🔫", type:"tools"},
    {label : "bomb", content: "💣", type:"tools"},
    {label : "hocho", content: "🔪", type:"tools"},
    {label : "dagger", content: "🗡", type:"tools"},
    {label : "crossed-swords", content: "⚔", type:"tools"},
    {label : "shield", content: "🛡", type:"tools"},
    {label : "smoking", content: "🚬", type:"tools"},
    {label : "skull-and-crossbones", content: "☠", type:"tools"},
    {label : "coffin", content: "⚰", type:"tools"},
    {label : "funeral-urn", content: "⚱", type:"tools"},
    {label : "amphora", content: "🏺", type:"tools"},
    {label : "crystal-ball", content: "🔮", type:"tools"},
    {label : "prayer-beads", content: "📿", type:"tools"},
    {label : "barber", content: "💈", type:"tools"},
    {label : "alembic", content: "⚗", type:"tools"},
    {label : "telescope", content: "🔭", type:"tools"},
    {label : "microscope", content: "🔬", type:"tools"},
    {label : "hole", content: "🕳", type:"tools"},
    {label : "pill", content: "💊", type:"tools"},
    {label : "syringe", content: "💉", type:"tools"},
    {label : "thermometer", content: "🌡", type:"tools"},
    {label : "label", content: "🏷", type:"tools"},
    {label : "bookmark", content: "🔖", type:"tools"},
    {label : "toilet", content: "🚽", type:"tools"},
    {label : "shower", content: "🚿", type:"tools"},
    {label : "bathtub", content: "🛁", type:"tools"},
    {label : "key", content: "🔑", type:"tools"},
    {label : "old-key", content: "🗝", type:"tools"},
    {label : "couch-and-lamp", content: "🛋", type:"tools"},
    {label : "sleeping-bed", content: "🛌", type:"tools"},
    {label : "bed", content: "🛏", type:"tools"},
    {label : "door", content: "🚪", type:"tools"},
    {label : "bellhop-bell", content: "🛎", type:"tools"},
    {label : "framed-picture", content: "🖼", type:"tools"},
    {label : "world-map", content: "🗺", type:"tools"},
    {label : "parasol-on-ground", content: "⛱", type:"tools"},
    {label : "moyai", content: "🗿", type:"tools"},
    {label : "shopping", content: "🛍", type:"tools"},
    {label : "shopping-cart", content: "🛒", type:"tools"},
    {label : "balloon", content: "🎈", type:"tools"},
    {label : "flags", content: "🎏", type:"tools"},
    {label : "ribbon", content: "🎀", type:"tools"},
    {label : "gift", content: "🎁", type:"tools"},
    {label : "confetti-ball", content: "🎊", type:"tools"},
    {label : "tada", content: "🎉", type:"tools"},
    {label : "dolls", content: "🎎", type:"tools"},
    {label : "wind-chime", content: "🎐", type:"tools"},
    {label : "crossed-flags", content: "🎌", type:"tools"},
    {label : "izakaya-lantern", content: "🏮", type:"tools"},
    {label : "envelope-with-arrow", content: "📩", type:"tools"},
    {label : "incoming-envelope", content: "📨", type:"tools"},
    {label : "e-mail", content: "📧", type:"tools"},
    {label : "love-letter", content: "💌", type:"tools"},
    {label : "postbox", content: "📮", type:"tools"},
    {label : "mailbox-closed", content: "📪", type:"tools"},
    {label : "mailbox", content: "📫", type:"tools"},
    {label : "mailbox-with-mail", content: "📬", type:"tools"},
    {label : "mailbox-with-no-mail", content: "📭", type:"tools"},
    {label : "package", content: "📦", type:"tools"},
    {label : "postal-horn", content: "📯", type:"tools"},
    {label : "inbox-tray", content: "📥", type:"tools"},
    {label : "outbox-tray", content: "📤", type:"tools"},
    {label : "scroll", content: "📜", type:"tools"},
    {label : "page-with-curl", content: "📃", type:"tools"},
    {label : "bookmark-tabs", content: "📑", type:"tools"},
    {label : "bar-chart", content: "📊", type:"tools"},
    {label : "chart-with-upwards-trend", content: "📈", type:"tools"},
    {label : "chart-with-downwards-trend", content: "📉", type:"tools"},
    {label : "page-facing-up", content: "📄", type:"tools"},
    {label : "date", content: "📅", type:"tools"},
    {label : "calendar", content: "📆", type:"tools"},
    {label : "spiral-calendar", content: "🗓", type:"tools"},
    {label : "card-index", content: "📇", type:"tools"},
    {label : "card-file-box", content: "🗃", type:"tools"},
    {label : "ballot-box", content: "🗳", type:"tools"},
    {label : "file-cabinet", content: "🗄", type:"tools"},
    {label : "clipboard", content: "📋", type:"tools"},
    {label : "spiral-notepad", content: "🗒", type:"tools"},
    {label : "file-folder", content: "📁", type:"tools"},
    {label : "open-file-folder", content: "📂", type:"tools"},
    {label : "card-index-dividers", content: "🗂", type:"tools"},
    {label : "newspaper-roll", content: "🗞", type:"tools"},
    {label : "newspaper", content: "📰", type:"tools"},
    {label : "notebook", content: "📓", type:"tools"},
    {label : "closed-book", content: "📕", type:"tools"},
    {label : "green-book", content: "📗", type:"tools"},
    {label : "blue-book", content: "📘", type:"tools"},
    {label : "orange-book", content: "📙", type:"tools"},
    {label : "notebook-with-decorative-cover", content: "📔", type:"tools"},
    {label : "ledger", content: "📒", type:"tools"},
    {label : "books", content: "📚", type:"tools"},
    {label : "open-book", content: "📖", type:"tools"},
    {label : "link", content: "🔗", type:"tools"},
    {label : "paperclip", content: "📎", type:"tools"},
    {label : "paperclips", content: "🖇", type:"tools"},
    {label : "triangular-ruler", content: "📐", type:"tools"},
    {label : "straight-ruler", content: "📏", type:"tools"},
    {label : "pushpin", content: "📌", type:"tools"},
    {label : "round-pushpin", content: "📍", type:"tools"},
    {label : "triangular-flag-on-post", content: "🚩", type:"tools"},
    {label : "white-flag", content: "🏳", type:"tools"},
    {label : "black-flag", content: "🏴", type:"tools"},
    {label : "closed-lock-with-key", content: "🔐", type:"tools"},
    {label : "lock", content: "🔒", type:"tools"},
    {label : "unlock", content: "🔓", type:"tools"},
    {label : "lock-with-ink-pen", content: "🔏", type:"tools"},
    {label : "pen", content: "🖊", type:"tools"},
    {label : "fountain-pen", content: "🖋", type:"tools"},
    {label : "memo", content: "📝", type:"tools"},
    {label : "crayon", content: "🖍", type:"tools"},
    {label : "paintbrush", content: "🖌", type:"tools"},
    {label : "mag", content: "🔍", type:"tools"},
    {label : "mag-right", content: "🔎", type:"tools"},
    {label : "yellow-heart", content: "💛", type:"smiley"},
    {label : "green-heart", content: "💚", type:"smiley"},
    {label : "blue-heart", content: "💙", type:"smiley"},
    {label : "purple-heart", content: "💜", type:"smiley"},
    {label : "black-heart", content: "🖤", type:"smiley"},
    {label : "broken-heart", content: "💔", type:"smiley"},
    {label : "heavy-heart-exclamation", content: "❣", type:"smiley"},
    {label : "two-hearts", content: "💕", type:"smiley"},
    {label : "revolving-hearts", content: "💞", type:"smiley"},
    {label : "heartbeat", content: "💓", type:"smiley"},
    {label : "heartpulse", content: "💗", type:"smiley"},
    {label : "sparkling-heart", content: "💖", type:"smiley"},
    {label : "cupid", content: "💘", type:"smiley"},
    {label : "gift-heart", content: "💝", type:"smiley"},
    {label : "heart-decoration", content: "💟", type:"smiley"},
    {label : "peace-symbol", content: "☮", type:"panels"},
    {label : "latin-cross", content: "✝", type:"panels"},
    {label : "star-and-crescent", content: "☪", type:"panels"},
    {label : "om", content: "🕉", type:"panels"},
    {label : "wheel-of-dharma", content: "☸", type:"panels"},
    {label : "star-of-david", content: "✡", type:"panels"},
    {label : "six-pointed-star", content: "🔯", type:"panels"},
    {label : "menorah", content: "🕎", type:"panels"},
    {label : "yin-yang", content: "☯", type:"panels"},
    {label : "orthodox-cross", content: "☦", type:"panels"},
    {label : "place-of-worship", content: "🛐", type:"panels"},
    {label : "ophiuchus", content: "⛎", type:"panels"},
    {label : "aries", content: "♈", type:"panels"},
    {label : "taurus", content: "♉", type:"panels"},
    {label : "gemini", content: "♊", type:"panels"},
    {label : "cancer", content: "♋", type:"panels"},
    {label : "leo", content: "♌", type:"panels"},
    {label : "virgo", content: "♍", type:"panels"},
    {label : "libra", content: "♎", type:"panels"},
    {label : "scorpius", content: "♏", type:"panels"},
    {label : "sagittarius", content: "♐", type:"panels"},
    {label : "capricorn", content: "♑", type:"panels"},
    {label : "aquarius", content: "♒", type:"panels"},
    {label : "pisces", content: "♓", type:"panels"},
    {label : "id", content: "🆔", type:"panels"},
    {label : "atom-symbol", content: "⚛", type:"panels"},
    {label : "u7a7a", content: "🈳", type:"panels"},
    {label : "u5272", content: "🈹", type:"panels"},
    {label : "radioactive", content: "☢", type:"panels"},
    {label : "biohazard", content: "☣", type:"panels"},
    {label : "mobile-phone-off", content: "📴", type:"panels"},
    {label : "vibration-mode", content: "📳", type:"panels"},
    {label : "u6709", content: "🈶", type:"panels"},
    {label : "u7121", content: "🈚", type:"panels"},
    {label : "u7533", content: "🈸", type:"panels"},
    {label : "u55b6", content: "🈺", type:"panels"},
    {label : "vs", content: "🆚", type:"panels"},
    {label : "accept", content: "🉑", type:"panels"},
    {label : "white-flower", content: "💮", type:"panels"},
    {label : "ideograph-advantage", content: "🉐", type:"panels"},
    {label : "u5408", content: "🈴", type:"panels"},
    {label : "u6e80", content: "🈵", type:"panels"},
    {label : "u7981", content: "🈲", type:"panels"},
    {label : "ab", content: "🆎", type:"panels"},
    {label : "cl", content: "🆑", type:"panels"},
    {label : "sos", content: "🆘", type:"panels"},
    {label : "no-entry", content: "⛔", type:"panels"},
    {label : "name-badge", content: "📛", type:"panels"},
    {label : "no-entry-sign", content: "🚫", type:"panels"},
    {label : "x", content: "❌", type:"panels"},
    {label : "o", content: "⭕", type:"panels"},
    {label : "stop-sign", content: "🛑", type:"panels"},
    {label : "anger", content: "💢", type:"panels"},
    {label : "no-pedestrians", content: "🚷", type:"panels"},
    {label : "do-not-litter", content: "🚯", type:"panels"},
    {label : "no-bicycles", content: "🚳", type:"panels"},
    {label : "non-potable-water", content: "🚱", type:"panels"},
    {label : "underage", content: "🔞", type:"panels"},
    {label : "no-mobile-phones", content: "📵", type:"panels"},
    {label : "exclamation", content: "❗", type:"panels"},
    {label : "grey-exclamation", content: "❕", type:"panels"},
    {label : "question", content: "❓", type:"panels"},
    {label : "grey-question", content: "❔", type:"panels"},
    {label : "low-brightness", content: "🔅", type:"panels"},
    {label : "high-brightness", content: "🔆", type:"panels"},
    {label : "trident", content: "🔱", type:"panels"},
    {label : "fleur-de-lis", content: "⚜", type:"panels"},
    {label : "children-crossing", content: "🚸", type:"panels"},
    {label : "beginner", content: "🔰", type:"panels"},
    {label : "u6307", content: "🈯", type:"panels"},
    {label : "chart", content: "💹", type:"panels"},
    {label : "negative-squared-cross-mark", content: "❎", type:"panels"},
    {label : "white-check-mark", content: "✅", type:"panels"},
    {label : "diamond-shape-with-a-dot-inside", content: "💠", type:"panels"},
    {label : "cyclone", content: "🌀", type:"panels"},
    {label : "loop", content: "➿", type:"panels"},
    {label : "globe-with-meridians", content: "🌐", type:"panels"},
    {label : "atm", content: "🏧", type:"panels"},
    {label : "passport-control", content: "🛂", type:"panels"},
    {label : "customs", content: "🛃", type:"panels"},
    {label : "baggage-claim", content: "🛄", type:"panels"},
    {label : "left-luggage", content: "🛅", type:"panels"},
    {label : "wheelchair", content: "♿", type:"panels"},
    {label : "no-smoking", content: "🚭", type:"panels"},
    {label : "wc", content: "🚾", type:"panels"},
    {label : "potable-water", content: "🚰", type:"panels"},
    {label : "mens", content: "🚹", type:"panels"},
    {label : "womens", content: "🚺", type:"panels"},
    {label : "baby-symbol", content: "🚼", type:"panels"},
    {label : "restroom", content: "🚻", type:"panels"},
    {label : "put-litter-in-its-place", content: "🚮", type:"panels"},
    {label : "cinema", content: "🎦", type:"panels"},
    {label : "signal-strength", content: "📶", type:"panels"},
    {label : "koko", content: "🈁", type:"panels"},
    {label : "ng", content: "🆖", type:"panels"},
    {label : "ok", content: "🆗", type:"panels"},
    {label : "up", content: "🆙", type:"panels"},
    {label : "cool", content: "🆒", type:"panels"},
    {label : "new", content: "🆕", type:"panels"},
    {label : "free", content: "🆓", type:"panels"},
    {label : "keycap-ten", content: "🔟", type:"panels"},
    {label : "pause-button", content: "⏸", type:"panels"},
    {label : "next-track-button", content: "⏭", type:"panels"},
    {label : "stop-button", content: "⏹", type:"panels"},
    {label : "record-button", content: "⏺", type:"panels"},
    {label : "play-or-pause-button", content: "⏯", type:"panels"},
    {label : "previous-track-button", content: "⏮", type:"panels"},
    {label : "fast-forward", content: "⏩", type:"panels"},
    {label : "rewind", content: "⏪", type:"panels"},
    {label : "twisted-rightwards-arrows", content: "🔀", type:"panels"},
    {label : "repeat", content: "🔁", type:"panels"},
    {label : "repeat-one", content: "🔂", type:"panels"},
    {label : "arrow-up-small", content: "🔼", type:"panels"},
    {label : "arrow-down-small", content: "🔽", type:"panels"},
    {label : "arrow-double-up", content: "⏫", type:"panels"},
    {label : "arrow-double-down", content: "⏬", type:"panels"},
    {label : "arrows-counterclockwise", content: "🔄", type:"panels"},
    {label : "abc", content: "🔤", type:"panels"},
    {label : "abcd", content: "🔡", type:"panels"},
    {label : "capital-abcd", content: "🔠", type:"panels"},
    {label : "symbols", content: "🔣", type:"panels"},
    {label : "musical-note", content: "🎵", type:"panels"},
    {label : "notes", content: "🎶", type:"panels"},
    {label : "curly-loop", content: "➰", type:"panels"},
    {label : "arrows-clockwise", content: "🔃", type:"panels"},
    {label : "heavy-plus-sign", content: "➕", type:"panels"},
    {label : "heavy-minus-sign", content: "➖", type:"panels"},
    {label : "heavy-division-sign", content: "➗", type:"panels"},
    {label : "heavy-dollar-sign", content: "💲", type:"panels"},
    {label : "currency-exchange", content: "💱", type:"panels"},
    {label : "end", content: "🔚", type:"panels"},
    {label : "back", content: "🔙", type:"panels"},
    {label : "on", content: "🔛", type:"panels"},
    {label : "top", content: "🔝", type:"panels"},
    {label : "soon", content: "🔜", type:"panels"},
    {label : "radio-button", content: "🔘", type:"panels"},
    {label : "white-circle", content: "⚪", type:"panels"},
    {label : "black-circle", content: "⚫", type:"panels"},
    {label : "red-circle", content: "🔴", type:"panels"},
    {label : "large-blue-circle", content: "🔵", type:"panels"},
    {label : "small-orange-diamond", content: "🔸", type:"panels"},
    {label : "small-blue-diamond", content: "🔹", type:"panels"},
    {label : "large-orange-diamond", content: "🔶", type:"panels"},
    {label : "large-blue-diamond", content: "🔷", type:"panels"},
    {label : "small-red-triangle", content: "🔺", type:"panels"},
    {label : "black-large-square", content: "⬛", type:"panels"},
    {label : "white-large-square", content: "⬜", type:"panels"},
    {label : "small-red-triangle-down", content: "🔻", type:"panels"},
    {label : "black-medium-small-square", content: "◾", type:"panels"},
    {label : "white-medium-small-square", content: "◽", type:"panels"},
    {label : "black-square-button", content: "🔲", type:"panels"},
    {label : "white-square-button", content: "🔳", type:"panels"},
    {label : "speaker", content: "🔈", type:"panels"},
    {label : "sound", content: "🔉", type:"panels"},
    {label : "loud-sound", content: "🔊", type:"panels"},
    {label : "mute", content: "🔇", type:"panels"},
    {label : "mega", content: "📣", type:"panels"},
    {label : "loudspeaker", content: "📢", type:"panels"},
    {label : "bell", content: "🔔", type:"panels"},
    {label : "no-bell", content: "🔕", type:"panels"},
    {label : "black-joker", content: "🃏", type:"panels"},
    {label : "mahjong", content: "🀄", type:"panels"},
    {label : "flower-playing-cards", content: "🎴", type:"panels"},
    {label : "thought-balloon", content: "💭", type:"panels"},
    {label : "right-anger-bubble", content: "🗯", type:"panels"},
    {label : "speech-balloon", content: "💬", type:"panels"},
    {label : "left-speech-bubble", content: "🗨", type:"panels"},
    {label : "clock1", content: "🕐", type:"clock"},
    {label : "clock2", content: "🕑", type:"clock"},
    {label : "clock3", content: "🕒", type:"clock"},
    {label : "clock4", content: "🕓", type:"clock"},
    {label : "clock5", content: "🕔", type:"clock"},
    {label : "clock6", content: "🕕", type:"clock"},
    {label : "clock7", content: "🕖", type:"clock"},
    {label : "clock8", content: "🕗", type:"clock"},
    {label : "clock9", content: "🕘", type:"clock"},
    {label : "clock10", content: "🕙", type:"clock"},
    {label : "clock11", content: "🕚", type:"clock"},
    {label : "clock12", content: "🕛", type:"clock"},
    {label : "clock130", content: "🕜", type:"clock"},
    {label : "clock230", content: "🕝", type:"clock"},
    {label : "clock330", content: "🕞", type:"clock"},
    {label : "clock430", content: "🕟", type:"clock"},
    {label : "clock530", content: "🕠", type:"clock"},
    {label : "clock630", content: "🕡", type:"clock"},
    {label : "clock730", content: "🕢", type:"clock"},
    {label : "clock830", content: "🕣", type:"clock"},
    {label : "clock930", content: "🕤", type:"clock"},
    {label : "clock1030", content: "🕥", type:"clock"},
    {label : "clock1130", content: "🕦", type:"clock"},
    {label : "clock1230", content: "🕧", type:"clock"},
];